import view from '../../view';
import { connectedStore } from '../../store';
import wrapperMap from '../helpers/wrapper-map';

const undoWrapper = (wrapperId) => {
  const wrapper = wrapperMap.getWrapperById(wrapperId);
  if (!wrapper) throw new Error('wrapper with specified id is not exist');

  const liveDocument = view.accessors.getLiveDocument();
  const store = connectedStore.get();
  const state = store.getState();
  const elementId = view.selectors.getFocusedElement(state);
  const element = view.accessors.getLiveElement(elementId);

  // When we're clicking on control pane trigger element loses focus and we should focus it manually
  // for correct work
  element.focus();

  wrapper.undoToSelection(liveDocument.defaultView);
};

export default undoWrapper;
